import { TThunkAction } from '../../types/redux';
import { selectActivePaymentMethod } from '../../selectors/paymentMethods';
import { setAmountError } from '../../actions/layout';
import { selectPaymentAmount } from '../../selectors/checkout';
import { validatePaymentAmount } from './utils';
import { selectWidgetMode } from '../../selectors/layout';

export const validateFormThunk: TThunkAction<boolean> = (dispatch, getState) => {
  const state = getState();
  const mode = selectWidgetMode(state);
  const { min, max } = selectActivePaymentMethod(state);
  const paymentAmount = selectPaymentAmount(state);

  const paymentAmountError = validatePaymentAmount({ mode, amount: paymentAmount, min, max });
  const isPaymentAmountValid = paymentAmountError === null;
  dispatch(setAmountError(paymentAmountError));

  const isValid = isPaymentAmountValid;

  return isValid;
};
